var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b08xcgzzpa",
    x1: "61.034%",
    x2: "26.503%",
    y1: "4.948%",
    y2: "71.907%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1%",
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26%",
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51%",
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76%",
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zfkfb63b0b",
    x1: "107.685%",
    x2: "-130.64%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "41%",
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "78%",
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xun9l0mmdc",
    x1: "86.219%",
    x2: "-50.15%",
    y1: "30.911%",
    y2: "135.988%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1lma0u4jnd",
    x1: "-18.754%",
    x2: "42.121%",
    y1: "-11.832%",
    y2: "35.095%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "7%",
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "48%",
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00F076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    fill: "#000",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M68.14 21.75c-2.345.011-4.237 1.919-4.23 4.263.007 2.345 1.912 4.24 4.257 4.237 2.344-.004 4.243-1.905 4.243-4.25.016-1.136-.429-2.23-1.234-3.03-.805-.802-1.9-1.242-3.036-1.22zm0 6.83c-1.057.074-2.051-.506-2.508-1.462-.457-.955-.283-2.093.439-2.869.721-.776 1.844-1.031 2.83-.645.987.387 1.636 1.337 1.639 2.396.033.663-.204 1.31-.656 1.796-.452.486-1.08.769-1.744.784zm-9.31-6.83c-2.346.006-4.244 1.91-4.24 4.257.004 2.346 1.907 4.245 4.253 4.243 2.346-.002 4.247-1.904 4.247-4.25.016-1.136-.429-2.23-1.234-3.03-.805-.802-1.9-1.242-3.036-1.22h.01zm0 6.83c-1.057.078-2.055-.499-2.515-1.454-.46-.955-.288-2.095.432-2.872.72-.778 1.844-1.036 2.831-.65.988.385 1.64 1.336 1.642 2.396.033.663-.204 1.31-.656 1.796-.452.486-1.08.769-1.744.784h.01zm-11.09-5.52v1.8h4.32c-.068.848-.42 1.648-1 2.27-.874.89-2.083 1.37-3.33 1.32-2.651 0-4.8-2.149-4.8-4.8s2.149-4.8 4.8-4.8c1.218-.02 2.394.444 3.27 1.29l1.27-1.27c-1.195-1.21-2.83-1.885-4.53-1.87-2.421-.094-4.7 1.144-5.938 3.226-1.239 2.082-1.239 4.676 0 6.758 1.238 2.082 3.517 3.32 5.938 3.226 1.732.078 3.413-.596 4.61-1.85 1.048-1.151 1.607-2.664 1.56-4.22.003-.379-.03-.757-.1-1.13l-6.07.05zm45.31 1.4c-.534-1.57-1.982-2.649-3.64-2.71-1.106-.002-2.163.453-2.92 1.259-.758.805-1.15 1.888-1.08 2.991-.025 1.13.411 2.22 1.207 3.022.796.801 1.884 1.245 3.013 1.228 1.42.008 2.75-.699 3.54-1.88l-1.45-1c-.44.734-1.234 1.182-2.09 1.18-.886.034-1.703-.478-2.06-1.29l5.69-2.35-.21-.45zm-5.8 1.42c-.04-.625.171-1.24.589-1.706.418-.467 1.005-.746 1.631-.774.66-.043 1.281.31 1.58.9l-3.8 1.58zM82.63 30h1.87V17.5h-1.87V30zm-3.06-7.3h-.07c-.57-.637-1.385-1.001-2.24-1-2.27.11-4.054 1.982-4.054 4.255 0 2.273 1.784 4.145 4.054 4.255.858.014 1.678-.352 2.24-1h.06v.61c0 1.63-.87 2.5-2.27 2.5-.954-.022-1.8-.619-2.14-1.51l-1.63.68c.628 1.527 2.12 2.52 3.77 2.51 2.19 0 4-1.29 4-4.43V22h-1.72v.7zm-2.14 5.88c-1.337-.118-2.363-1.238-2.363-2.58s1.026-2.462 2.363-2.58c.646.033 1.251.326 1.679.811.427.486.64 1.124.591 1.769.055.648-.157 1.29-.588 1.778-.43.487-1.042.777-1.692.802h.01zm24.38-11.08h-4.47V30h1.87v-4.74h2.61c1.453.104 2.842-.611 3.6-1.855s.758-2.806 0-4.05c-.758-1.244-2.147-1.96-3.6-1.855h-.01zm0 6H99.2v-4.26h2.65c1.185 0 2.145.96 2.145 2.145s-.96 2.145-2.145 2.145l-.04-.03zm11.53-1.8c-1.391-.083-2.7.667-3.33 1.91l1.66.69c.334-.616 1.001-.977 1.7-.92.48-.056.961.083 1.338.386.376.302.614.744.662 1.224v.13c-.6-.318-1.27-.483-1.95-.48-1.79 0-3.6 1-3.6 2.81.036.78.385 1.512.97 2.03.583.518 1.352.778 2.13.72.96.069 1.88-.391 2.4-1.2h.06v1h1.8v-4.81c0-2.19-1.66-3.46-3.79-3.46l-.05-.03zm-.23 6.85c-.61 0-1.46-.31-1.46-1.06 0-1 1.06-1.33 2-1.33.594-.015 1.181.13 1.7.42-.13 1.12-1.063 1.973-2.19 2l-.05-.03zM123.74 22l-2.14 5.42h-.06L119.32 22h-2l3.33 7.58-1.9 4.21h1.95L125.82 22h-2.08zm-16.81 8h1.87V17.5h-1.87V30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 0.2,
    d: "M47.42 10.24c.034.741-.237 1.464-.75 2-.574.596-1.374.92-2.2.89-1.268-.01-2.406-.779-2.888-1.951-.483-1.172-.215-2.52.678-3.419.58-.593 1.38-.918 2.21-.9.423-.001.841.084 1.23.25.362.146.684.376.94.67l-.53.53c-.405-.481-1.012-.744-1.64-.71-.631-.003-1.236.251-1.676.704-.44.453-.676 1.065-.654 1.696-.013.953.548 1.82 1.423 2.2.875.378 1.892.193 2.577-.47.308-.333.485-.766.5-1.22h-2.17v-.72h2.91c.027.149.04.3.04.45h0zM52 7.74h-2.7v1.9h2.46v.72H49.3v1.9H52V13h-3.5V7H52v.74zM55.28 13h-.77V7.74h-1.68V7H57v.74h-1.72V13zm4.66 0V7h.77v6h-.77zm4.19 0h-.77V7.74h-1.68V7h4.12v.74h-1.67V13zm9.48-.78c-1.217 1.21-3.183 1.21-4.4 0-1.18-1.249-1.18-3.201 0-4.45.582-.586 1.374-.916 2.2-.916.826 0 1.618.33 2.2.916 1.185 1.247 1.185 3.203 0 4.45h0zm-3.83-.5c.901.898 2.359.898 3.26 0 .885-.976.885-2.464 0-3.44-.901-.898-2.359-.898-3.26 0-.885.976-.885 2.464 0 3.44h0zm5.8 1.28V7h.94l2.92 4.67V7h.77v6h-.8l-3.05-4.89V13h-.78z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b08xcgzzpa)",
    d: "M1.44.54c-.326.391-.49.892-.46 1.4v22.12c-.03.508.134 1.009.46 1.4l.07.07L13.9 13.15v-.29L1.51.47l-.07.07z",
    transform: "translate(10 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zfkfb63b0b)",
    d: "M18 17.28l-4.1-4.13v-.29L18 8.72l.09.05L23 11.56c1.4.79 1.4 2.09 0 2.89l-4.89 2.78-.11.05z",
    transform: "translate(10 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#xun9l0mmdc)",
    d: "M18.12 17.22L13.9 13 1.44 25.46c.589.518 1.462.543 2.08.06l14.61-8.3",
    transform: "translate(10 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#1lma0u4jnd)",
    d: "M18.12 8.78L3.51.48C2.892-.003 2.019.022 1.43.54L13.9 13l4.22-4.22z",
    transform: "translate(10 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18 17.13L3.51 25.38c-.593.443-1.407.443-2 0l-.07.07.07.07c.592.447 1.408.447 2 0l14.61-8.3-.12-.09z",
    opacity: 0.2,
    transform: "translate(10 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.44 25.32c-.326-.391-.49-.892-.46-1.4v.15c-.03.508.134 1.009.46 1.4l.07-.07-.07-.08zM23 14.3l-5 2.83.09.09L23 14.44c.567-.266.948-.816 1-1.44-.114.565-.483 1.045-1 1.3z",
    opacity: 0.12,
    transform: "translate(10 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.51.62L23 11.7c.517.255.886.735 1 1.3-.052-.624-.433-1.174-1-1.44L3.51.48C2.11-.31.97.35.97 1.95v.15C1 .49 2.12-.17 3.51.62z",
    opacity: 0.25,
    transform: "translate(10 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.eff0aa6cfdc685190b654e90c29dd3d0.svg";
export { ForwardRef as ReactComponent };